export default "__VITE_ASSET__fa003d80__"